<template>
  <div>
    <div class="user_body">
      <el-table
        ref="multipleTable"
        :data="tableData"
        :header-cell-style="tableHeaderStyle"
        @selection-change="handleSelectionChange"
        v-loading="loading"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="title" label="产品名称" align="center" min-width="200">
          <template slot-scope="scope">
            <div class="div_product">
              <!-- <el-image :src="scope.row.thumb" class="product_img" :preview-src-list="[scope.row.thumb]"></el-image> -->
              <span>{{scope.row.title}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sku_name" label="规格" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.sku_name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="单价" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="total" label="数量" align="center">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.total"   @change="(newVal, oldVal) => handleChange(scope.row, newVal, oldVal)" :min="1" :max="scope.row.stock" label="描述文字"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="total_price" label="小计" align="center"></el-table-column>
        <el-table-column prop="time" label="操作" align="center">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small" style="color:#777777;">X</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="height:20px;background:#F3F3F6"></div>
      <div class="prices">
        <span class="tex1" style="padding-left:20px;">共</span>
        <span class="tex2">&nbsp;{{tableData.length}}&nbsp;</span>
        <span class="tex1">件 商品，已选择</span>
        <span class="tex2">&nbsp;{{multipleSelection.length}}&nbsp;</span>
        <span class="tex1" style="flex:1">件</span>
        <span class="tex2">合计：&nbsp;&nbsp;</span>
        <span class="tex3">{{totalPrice}}</span>
        <span class="tex2" style="padding-right:30px;">&nbsp;元</span>
        <span class="btn1" @click="onJiesuan">去结算</span>
      </div>
    </div>
    <div class="ss">推荐产品</div>
    <div class="remmcond">
      <div class="rem_item" v-for="(item,index) in recommendGoods" :key="index" @click="$router.push({path:'/productinfo/'+item.id+'?cateid='+item.category_id})">
        <img :src="item.thumb || ''">
        <span class="goods-title">{{item.title}}</span>
      </div>
    </div>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <span>确定删除购物车产品: 【{{currentCart.title}}】？</span>
      <span slot="footer" class="dialog-footer">
        <span @click="handleDelCart" class="btn44">确定</span>
        <span @click="dialogVisible = false" class="btn55">取消</span>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import bus from "@/components/eventBus.js";
export default {
  name: "SuggestionsView",
  data() {
    return {
      dialogVisible: false,
      tableData: [ ],
      multipleSelection: [],
      currentPage1: 5,
      total: 10,
      num: 1,
      loading: false,
      currentCart: {},
      recommendGoods: []
    };
  },
  created(){
    this.initData()
    this.getRecommendGoods();
  },
  mounted() {},
  computed: {
    totalPrice(){
      return this.multipleSelection.reduce((total, item) => total + item.total_price, 0)
    }
  },
  methods: {
    getRecommendGoods(){
      this.$api.getRecommendGoods().then(res => {
        if(res.code == 1){
          this.recommendGoods = res.data;
        }
      }).catch(err => {
        console.log(err);
      });
    },
    initData(){
      this.$api.getCart().then(res => {
        if(res.code == 1){
          this.tableData = res.data.list.map(item => {
            return {
              cart_id: item.id,
              // thumb: item.sku.thumb || item.goods.thumb,
              title: item.goods.title || '',
              sku_name: item.sku&&item.sku.sku_name?item.sku.sku_name:'',
              price: item.sku&&item.sku.price?item.sku.price:item.goods.price,
              total: item.total,
              stock: item.sku&&item.sku.stock?item.sku.stock:item.goods.stock,
              total_price: (item.sku&&item.sku.price?item.sku.price:item.goods.price) * item.total
            }
          })
        }else{
          this.$message.error(res.message)
        }
      }).catch(err => {
        this.$message.error(err.message||err.msg||"获取购物车失败")
      })
    },
   handleChange(row, newVal, oldVal) {
      if (newVal > oldVal) {
        console.log(`ID ${row.cart_id} 增加: ${oldVal} -> ${newVal}`);
        // 执行增加逻辑，例如更新库存或计算总价
      } else if (newVal < oldVal) {
        console.log(`ID ${row.cart_id} 减少: ${oldVal} -> ${newVal}`);
        // 执行减少逻辑
      }
      if(this.loading) return;
      this.loading = true;
      this.$api.editCart({cart_id:row.cart_id,total:newVal}).then(res => {
					this.loading = false;
					if(res.code == 1){
						row.total = newVal;
					}
					else{
						this.$message.error(res.message);
					}
				}).catch(err => {
					this.loading = false;
				});
    },
    handleClick(value) {
      console.log(value);
      this.currentCart = value;
      this.dialogVisible = true;
    },
    handleClose(){
      // this.dialogVisible = false;
    },
    // 设置表头的颜色
    tableHeaderStyle({ row, column, rowIndex, columnIndex }) {
      return "background-color: #ffffff; color:#333333;"; //
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    handleDelCart(){
      this.dialogVisible = false;
      this.$api.delCart({cart_ids:this.currentCart.cart_id}).then(res => {
        if(res.code == 1){
          this.initData();
        }
        else{
          this.$message.error(res.message);
        }
      }).catch(err => {
        this.$message.error(err.message||err.msg||"删除购物车失败")
      })
    },
    onJiesuan(){
				if(this.multipleSelection.length == 0){
					return this.$message.error("请选择产品");
				}
				this.$router.push({ path: "/confimorder?cart_id=" + this.multipleSelection.map(item => item.cart_id).join(",") }, () => {}, () => {});
			},
  }
};
</script> 

<style lang="less"  scoped>
.user_body {
  background: #ffffff;
  margin-left: 15%;
  margin-right: 15%;
  box-sizing: border-box;
  margin-top: 120px;
}
.prices {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 50px;
}
.tex2 {
  color: #3c9c8f;
  font-size: 14px;
}
.tex3 {
  color: #3c9c8f;
  font-size: 30px;
}
.tex1 {
  color: #666666;
  font-size: 14px;
}
.btn1 {
  cursor: pointer;
  background: #3c9c8f;
  color: white;
  font-size: 16px;
  height: 50px;
  width: 200px;
  line-height: 50px;
  text-align: center;
}
.ss {
  color: #3e3e3e;
  font-size: 44px;
  line-height: 60px;
  margin-left: 15%;
  margin-top: 40px;
  margin-bottom: 10px;
}
.remmcond {
  margin-left: 15%;
  margin-right: 15%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-bottom: 50px;
}
.rem_item {
  cursor: pointer;
  width: 24%;
  height: auto;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 1%;
  margin-top: 18px;
}
.rem_item img {
  width: 90%;
  aspect-ratio: 3/2;
  height: auto;
  margin-top: 20px;
  object-fit: cover;
}
.rem_item span {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
<style>
.custom-class {
  color: red;
  background: red !important;
}
::v-deep .custom-class {
  background-color: #ffffff; /* 设置为浅绿色 */
}
.el-table {
  border-bottom: 1px solid #ebeef5;
  background: #111111;
  width: 100%;
}
.footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
.div_product {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.product_img {
  width: 80px;
  height: 80px;
  margin-right: 10px;
}

.dialog-footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 0px;
  padding-top: 20px;
  padding-bottom: 20px;
}
.btn44 {
  cursor: pointer;
  background: #3c9c8f;
  color: white;
  width: 80px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin-right: 30px;
  border-radius: 2px;
}
.btn55 {
  cursor: pointer;
  background: white;
  color: #999999;
  width: 80px;
  height: 38px;
  text-align: center;
  line-height: 38px;
  border: 1px solid #999999;
  border-radius: 2px;
  margin-right: 16px;
}
</style>


